
// timer
export default function initTimer() {
  // Set the date we're counting down to
  var CustomDate = document.getElementById("timer");

  if (!CustomDate) return;

  var eventDate = CustomDate.getAttribute("data-event");
  var countDownDate = new Date(eventDate).getTime();

  var elHours = jQuery('.hours');
  var elMinutes = jQuery('.minutes');
  var elSeconds = jQuery('.seconds');
  
  // Update the count down every 1 second
  var x = setInterval(function() {
  
    // Get today's date and time
    var now = new Date().getTime();
  
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
  
    // Time calculations for days, hours, minutes
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    $(elHours).html(hours);
    $(elMinutes).html(minutes);
    $(elSeconds).html(seconds);
  
    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("timer").innerHTML = "EXPIRED";
    }
  }, 500);
}
